import {useEffect, useState} from 'react';
import {Button} from "@/components/ui/button";
import {SingleProductEnum} from "@/constants/commerce-enum";
import SingleProductServices from "@/http/api/single-product/SingleProductServices";
import WizardFormAuth from "@/components/global/modals/wizard-auth-form-modal";
import {useAuthStore} from "@/store/auth/authStore";


const {cancelAvailable, addAvailable, checkAvailable} = new SingleProductServices();


const AvailableButtonDesktop = ({unique_id}: { unique_id: string; }) => {
    const [isSendNotifyAvailable, setIsSendNotifyAvailable] = useState<boolean | null>(null);
    const {token} = useAuthStore(state => state);
    useEffect(() => {
        const checkAvailableNotify = async () => {
            try {
                const isNotifySend: any = await checkAvailable(unique_id);
                setIsSendNotifyAvailable(isNotifySend?.productNotificationExists);
            } catch (error) {
                console.error("Error checking availability notification:", error);
            }
        };
        checkAvailableNotify();
    }, [unique_id]);

    const notifyAvailable = async () => {
        try {
            await addAvailable(unique_id);
            setTimeout(() => setIsSendNotifyAvailable(true), 1000);
        } catch (error) {
            console.log("ADD AVAILABLE ERROR:", error);
        }
    };
    const cancelAvailableHandler = async () => {
        try {
            await cancelAvailable(unique_id);
            setTimeout(() => setIsSendNotifyAvailable(false), 1000);
        } catch (error) {
            console.log("CANCEL NOTIFICATION AVAILABLE", error);
        }
    };

    return (
        <div className="w-full h-[125px] flex flex-wrap border-gray-200 items-center justify-center gap-[25px]">
            {isSendNotifyAvailable ? (
                <>
                    {
                        token ? (
                            <Button
                                type={"button"}
                                variant={"outline"}
                                className="w-full p-6 rounded-2xl overflow-hidden"
                                onClick={cancelAvailableHandler}
                            >
                                {SingleProductEnum?.cancelNotify}
                            </Button>
                        ) : (
                            <WizardFormAuth customButton={
                                <Button
                                    type={"button"}
                                    variant={"outline"}
                                    className="w-full p-6 rounded-2xl overflow-hidden"
                                >
                                    {SingleProductEnum?.cancelNotify}
                                </Button>
                            }/>
                        )
                    }
                </>

            ) : (

                <>
                    {
                        token ? (
                            <Button
                                type={"button"}
                                className="w-full p-6 rounded-2xl overflow-hidden"
                                onClick={notifyAvailable}
                            >
                                {SingleProductEnum?.notifyProduct}
                            </Button>
                        ) : (
                            <WizardFormAuth customButton={
                                <Button
                                    type={"button"}
                                    className="w-full p-6 rounded-2xl overflow-hidden"
                                >
                                    {SingleProductEnum?.notifyProduct}
                                </Button>
                            }/>
                        )
                    }
                </>

            )}
        </div>
    );
};

export default AvailableButtonDesktop;
